// Anamnese: as mesmas perguntas e cuidados do protótipo (pesquisa da versão 56).
export interface AnQ { k: string; l: string; pub: string; none?: string; hint?: string; one?: boolean; o: string[] }
export const AN_STEPS: Array<{ t: string; pubT: string; qs: AnQ[] }> = [
  { t: 'Saúde', pubT: 'Sua saúde', qs: [
    { k: 'alergias', l: 'Alergias e reações', pub: 'Você tem alergia ou já teve reação a algum destes?', none: 'Nenhuma', hint: 'Coceira, vermelhidão ou unha descolando depois do gel também conta.',
      o: ['Acetona', 'Gel ou acrílico', 'Cola de unha', 'Esmalte comum', 'Látex', 'Perfumes e cremes'] },
    { k: 'saude', l: 'Saúde', pub: 'Algo sobre a sua saúde que devemos saber?', none: 'Nada a declarar',
      o: ['Diabetes', 'Má circulação', 'Usa anticoagulante', 'Tratamento de câncer', 'Imunidade baixa', 'Gestante ou amamentando', 'Lúpus ou sensível ao sol', 'Psoríase ou dermatite'] },
    { k: 'remedios', l: 'Remédios', pub: 'Está tomando algum destes?', none: 'Nenhum', o: ['Roacutan (isotretinoína)', 'Antibiótico', 'Corticoide', 'Outro de uso contínuo'] },
  ] },
  { t: 'Unhas e rotina', pubT: 'Suas unhas', qs: [
    { k: 'unhas', l: 'Unhas e pele hoje', pub: 'Como estão suas unhas e sua pele?', none: 'Tudo bem',
      o: ['Unhas frágeis', 'Roe as unhas', 'Unha descolando', 'Suspeita de micose', 'Unha encravada', 'Ferida ou inflamação', 'Pele sensível', 'Calos ou rachaduras nos pés'] },
    { k: 'historico', l: 'Já usou', pub: 'Já usou alguma destas?', none: 'Nunca usou alongamento', o: ['Gel', 'Fibra de vidro', 'Acrílico', 'Unha postiça', 'Tirou arrancando da última vez'] },
    { k: 'rotina', l: 'Dia a dia das mãos', pub: 'No dia a dia, suas mãos…', none: 'Nada especial', o: ['Ficam muito na água', 'Usam produtos de limpeza', 'Digitam muito', 'Fazem trabalho pesado', 'Academia ou esporte'] },
  ] },
  { t: 'Preferências', pubT: 'Do seu jeito', qs: [
    { k: 'cuticula', one: true, l: 'Cutícula', pub: 'Na cutícula, você prefere', o: ['Tirar tudo', 'Tirar pouco', 'Só empurrar'] },
    { k: 'formato', one: true, l: 'Formato', pub: 'Formato preferido', o: ['Quadrado', 'Redondo', 'Amendoado', 'Bailarina', 'Stiletto'] },
    { k: 'comprimento', one: true, l: 'Comprimento', pub: 'Comprimento', o: ['Curto', 'Médio', 'Longo'] },
    { k: 'conforto', l: 'Para ficar à vontade', pub: 'Para você ficar à vontade', none: 'Tanto faz', o: ['Sem lixa elétrica', 'Sente dor fácil', 'Prefere conversar pouco'] },
  ] },
];

export type Lvl = 'stop' | 'care' | 'info';
export const AN_CARE: Record<string, [Lvl, string]> = {
  'Acetona': ['care', 'Remover com removedor sem acetona.'],
  'Gel ou acrílico': ['stop', 'Não usar gel, acrílico nem fibra: só esmalte comum. Insistir pode piorar a alergia.'],
  'Cola de unha': ['care', 'Sem cola: nada de unha postiça colada.'],
  'Esmalte comum': ['care', 'Usar esmalte hipoalergênico, sem formol e tolueno.'],
  'Látex': ['care', 'Luvas de nitrilo, nunca de látex.'],
  'Perfumes e cremes': ['care', 'Finalizar sem creme ou óleo perfumado.'],
  'Diabetes': ['care', 'Não cortar cutícula nem pele do pé. Água morna. Se vir ferida, não atender a área e indicar médico.'],
  'Má circulação': ['care', 'Água morna, nunca quente. Massagem leve.'],
  'Usa anticoagulante': ['care', 'Sangra com facilidade: só empurrar a cutícula, sem alicate.'],
  'Tratamento de câncer': ['care', 'Não tirar cutícula. Material descartável. Gel só com liberação do médico.'],
  'Imunidade baixa': ['care', 'Não tirar cutícula. Material descartável.'],
  'Gestante ou amamentando': ['info', 'Sala bem ventilada. Pergunte se algum cheiro incomoda.'],
  'Lúpus ou sensível ao sol': ['care', 'Evitar a cabine UV: esmalte comum ou luva com proteção UV.'],
  'Psoríase ou dermatite': ['care', 'Não lixar nem cortar onde houver lesão.'],
  'Roacutan (isotretinoína)': ['care', 'Unha e pele mais finas: lixar com leveza e não tirar cutícula.'],
  'Antibiótico': ['info', 'Alguns deixam a pele sensível à luz: pergunte antes da cabine UV.'],
  'Corticoide': ['info', 'Pele mais fina: cuidado com o alicate.'],
  'Unha descolando': ['care', 'Não aplicar gel na unha descolada. Sugerir avaliação com dermatologista.'],
  'Suspeita de micose': ['stop', 'Não atender a unha afetada. Separar o material para esterilizar e sugerir dermatologista.'],
  'Ferida ou inflamação': ['stop', 'Não atender a área até sarar.'],
  'Unha encravada': ['care', 'Não cortar o canto. Se estiver inflamada, sugerir podólogo.'],
  'Pele sensível': ['info', 'Lixa fina e produtos suaves.'],
  'Tirou arrancando da última vez': ['info', 'A unha natural pode estar fina: avaliar antes de alongar.'],
  'Ficam muito na água': ['info', 'Mais chance de descolar: reforçar a selagem e orientar luvas.'],
  'Usam produtos de limpeza': ['info', 'Orientar luvas para lavar louça e limpar.'],
  'Sem lixa elétrica': ['info', 'Só lixa manual.'],
  'Sente dor fácil': ['info', 'Ir com calma na cutícula e perguntar durante.'],
  'Prefere conversar pouco': ['info', 'Atendimento mais silencioso.'],
};
export const AN_LVL: Record<Lvl, string> = { stop: 'Não fazer', care: 'Cuidado', info: 'Bom saber' };

export type Answers = Record<string, string | string[]>;

// cuidados, do mais grave para o mais leve
export function cuidadosOf(x: Answers | null | undefined): Array<{ lvl: Lvl; src: string; txt: string }> {
  if (!x) return [];
  const out: Array<{ lvl: Lvl; src: string; txt: string }> = [];
  for (const k of ['alergias', 'saude', 'remedios', 'unhas', 'historico', 'rotina', 'conforto']) {
    const v = x[k];
    for (const o of Array.isArray(v) ? v : []) {
      const c = AN_CARE[o];
      if (c) out.push({ lvl: c[0], src: k === 'alergias' ? `Alergia a ${o.toLowerCase()}` : o, txt: c[1] });
    }
  }
  const rank = { stop: 0, care: 1, info: 2 };
  return out.sort((a, b) => rank[a.lvl] - rank[b.lvl]);
}
export const alertsOf = (x: Answers | null | undefined) => cuidadosOf(x).filter((c) => c.lvl !== 'info').map((c) => c.src.toLowerCase());
